/* Common Imports */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 5rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 5rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 5rem 72rem",
    },
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "0.5rem",
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    width: "100%",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 700,
    fontSize: "4rem",
    lineHeight: "5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.375rem",
      lineHeight: "2.85rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "2.375rem",
      lineHeight: "2.85rem",
    },
  },
  iframe: {
    height: "45rem",
    width: "100%",
    border: "none",
    [theme.breakpoints.down("xs")]: {
      height: "15rem",
      borderRadius: "24px", // Add border radius for mobile
    },
    [theme.breakpoints.only("sm")]: {
      height: "30rem",
      borderRadius: "24px", // Add border radius for small screens
    },
    [theme.breakpoints.only("md")]: {
      height: "40rem",
    },
    [theme.breakpoints.only("lg")]: {
      height: "40rem",
    },
    [theme.breakpoints.only("xl")]: {
      height: "45rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "50rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      height: "55rem",
    },
  },
  mainContainer: {
    padding: "0rem 8rem 2rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
}));
const VirtualTour = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {/* <div className={classes.megaContainer}> */}
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h6"
            component="h6"
            className={classes.heading}
          >
            Virtual Tour
          </Typography>
          <iframe
            height="200"
            width="300"
            loading="lazy"
            src="/virtualtour/index.html"
            className={classes.iframe}
          ></iframe>
        </div>
        {/* </div> */}
      </div>
    </React.Fragment>
  );
};
export default VirtualTour;
